import { render, staticRenderFns } from "./ContentBox.html?vue&type=template&id=1f7fd158&scoped=true&"
import script from "./ContentBox.js?vue&type=script&lang=js&"
export * from "./ContentBox.js?vue&type=script&lang=js&"
import style0 from "./ContentBox.scss?vue&type=style&index=0&id=1f7fd158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7fd158",
  null
  
)

export default component.exports